// Opening an entity from chat has no natural throttle: an "Open" button on a
// proposal card and a markdown entity chip both fire on every click, and each
// call stacks another modal/drawer or opens another browser tab. Spamming a
// link therefore opens an unbounded number of them.
//
// Both surfaces route through their own switch (openCrmEntity for cards,
// MessageBlock's click handler for chips), so the guard lives here rather than
// in either one. Kept free of drawer/modal imports so it stays unit-testable.
const REOPEN_GUARD_MS = 800;

const lastOpenedAt = new Map<string, number>();

/**
 * True when this exact target was opened moments ago and the click should be
 * dropped. Keyed by entity type + id, so opening a different record is never
 * blocked. The window is well under the time it takes to open a modal, read it
 * and close it again, so a deliberate re-open still goes through.
 */
export function shouldIgnoreRepeatOpen(entityType: string, id: number): boolean {
	const key = `${entityType.toLowerCase()}:${id}`;
	const now = Date.now();
	const previous = lastOpenedAt.get(key);
	lastOpenedAt.set(key, now);
	return previous != null && now - previous < REOPEN_GUARD_MS;
}

/** Test seam — the guard is module-level state shared by every caller. */
export function resetEntityOpenGuard(): void {
	lastOpenedAt.clear();
}
